export default class ConsumerList {
  constructor() {
    this.require = {
      container: "^consumerContainer"
    };
    this.bindings = {
      consumerId: "@",
      productListId: "@"
    };
  }

  templateUrl($element, $attrs) {
    return $attrs.templateUrl || "consumer-list.html";
  }
}

angular.module("emun.consumer").component("consumerList", new ConsumerList());
